
import {Component, Inject, OnInit} from '@angular/core';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import { constants } from 'src/app/shared/common/contants';
import { ReportConfigurationComponent } from '../report-configuration.component';
import { AsignUserRoleService } from 'src/app/shared/services/asign-user-role.service';




export interface checkinListDialogData {
  edata: any;
  page: any;
  columns: any;
  remarksData: any;
  childId: any;

}

 
@Component({
    selector: 'app-access-permission',
    templateUrl: './access-permission.component.html',
    styleUrls: ['./access-permission.component.scss'],
    standalone: false
})

export class AccessPermissionComponent implements OnInit {

  showDropdown: boolean  = false;
  selectedAccessValues: number[] = [];

  FormValid: UntypedFormGroup;
  backgroundColorButton = '';
  Accesstypes: any =[];
  UserRoleAccessvalues:any =[];
  isPublic:boolean  ;
  isRestricted:boolean ;
  
  
  assignUserRolePopupData = {
    
    'DatasetName': '',
    'reportcreationid': '',
    'datasetAccessType': '',
    'dataset_rolesIds':'',
    
    
  };


  constructor(public dialogref: MatDialogRef<AccessPermissionComponent>,private localStorageSettings: LocalStorageSettingsService, @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData,private service: ReportingServiceService,private snackbar: MatSnackBar,private constants: constants) {   }

  

  ngOnInit(): void {
    
    console.log(this.data);
     this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
     

        if (this.assignUserRolePopupData.DatasetName != undefined) {
           this.assignUserRolePopupData.DatasetName = this.data.edata.datasetname;
           this.assignUserRolePopupData.reportcreationid = this.data.edata.reportcreationid;
           /* modified by Chandra R
            *  modified code changed the variable names
            *  30-06-2024
            */
           this.assignUserRolePopupData.dataset_rolesIds= this.data.edata.dataset_rolesIds;
           this.assignUserRolePopupData.datasetAccessType=this.data.edata.datasetAccessType;
           
        }else{
            console.log(this.assignUserRolePopupData);
          }
    
       this.Useroles();
         
        // Updated the code uncheck the radio button if role is private
    if (this.data.edata.datasetAccessType == "Public") {
      this.isPublic = true;
      this.showDropdown = false;
      
      /* modified by Chandra R
       *  modified code validating by Restricted
       *  30-06-2024
       */
      
  }
  else if (this.data.edata.datasetAccessType == "Restricted") { 
      this.isRestricted = true; // This should be true for the "Restricted To" radio button to be selected
      this.showDropdown = true;
      this.UserRoleAccessvalues = this.data.edata.dataset_rolesIds.split(',').map(Number);
      console.log(this.UserRoleAccessvalues);
  }
    
       
  }
  

// Update's the selected Roles 
  updateData() {

   
  console.log("-----"+this.assignUserRolePopupData.datasetAccessType+"-----"+this.assignUserRolePopupData.dataset_rolesIds);
  
  if(this.assignUserRolePopupData.dataset_rolesIds == "" && this.assignUserRolePopupData.datasetAccessType ==  "Restricted" )
    {
    this.assignUserRolePopupData.datasetAccessType = "Private";
    
    }
    
    console.log(this.assignUserRolePopupData);
    console.log(this.assignUserRolePopupData.datasetAccessType);
    this.service.updateReportDatasetAccess(this.assignUserRolePopupData).subscribe((response) => {
      
      console.log(response);
      if(response.error == true)
      {
        this.snackbar.open(this.constants.Request_Failed ,"OK",{duration:5000});
        close();
        return;
      }
      else{
        this.snackbar.open("Updation Success","OK",{duration:5000});
        this.dialogref.close('updated');
        return;
      }
      
    },
    (error) => {
      console.error('Error while Updating the Access ', error);
    });
    
  
 }
  /* modified by Chandra R
   *  close the DropDown and makes and  unassigning Data from user roles object
   *  30-06-2024
   */
  close() {
  this.dialogref.close();
  this.assignUserRolePopupData.dataset_rolesIds ="";
  this.assignUserRolePopupData.DatasetName="";
  this.assignUserRolePopupData.reportcreationid="";
  this.assignUserRolePopupData.datasetAccessType="";
 }

// Fetches the User Roles
Useroles(): void {
    
  const dnsid = this.localStorageSettings.getSettings("dnsName");
  if(dnsid){
    //this.service.
    this.service.getUserRoles(this.localStorageSettings.getSettings("dnsName"))
    .subscribe(
      (response) => {
        this.Accesstypes = response; // Assign fetched user roles to the types array
        console.log(this.Accesstypes);
      },
      (error) => {
        console.error('Error fetching user roles:', error);
      }
    );
    }
  }

  
  
 changeUseroles(e) {
  this.assignUserRolePopupData.dataset_rolesIds = e.value.join(',');
  console.log(this.assignUserRolePopupData);
  this.assignUserRolePopupData.datasetAccessType =  "Restricted";
 }

// Initialize datasetAccessType based on Radio Button
 toggleDropdownforpublic(restricted: boolean) {
    this.showDropdown = false;
    this.assignUserRolePopupData.datasetAccessType = "Public";
    this.assignUserRolePopupData.dataset_rolesIds = "";
    this.UserRoleAccessvalues = [];
  
 }
// Initialize datasetAccessType based on Radio Button 
 toggleDropdownforrestricted(restricted: boolean){

  this.showDropdown = true;
  this.assignUserRolePopupData.datasetAccessType =  "Restricted";

 }

}
